import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as params from '../constants/wix-params';
import withAppSettings from './with-app-settings';
import getDisplayName from '../services/get-display-name';
import getLayoutName from '../services/get-layout-name';

export default function withFontClassName(WrappedComponent) {
  const Wrapper = class extends Component {
    static displayName = `WithFontClassNames(${getDisplayName(WrappedComponent)})`;

    static propTypes = {
      layoutType: PropTypes.number,
      cardSize: PropTypes.number,
      siteColors: PropTypes.object,
    };

    render() {
      const {
        layoutType,
        cardSize,
        siteColors, // eslint-disable-line no-unused-vars
        ...otherProps
      } = this.props;
      const layoutName = getLayoutName(layoutType, cardSize);
      const fontClassNames = {
        titleFontClassName: `forum-title-${layoutName}-font`,
        contentFontClassName: `forum-content-${layoutName}-font`,
      };

      return <WrappedComponent {...otherProps} {...fontClassNames}/>;
    }
  };

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return withAppSettings({
    layoutType: params.LAYOUT_TYPE_PATH,
    cardSize: params.CARD_SIZE_PATH,
  })(Wrapper);
}



// WEBPACK FOOTER //
// ./app/hoc/with-font-class-name.js